import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { collection, query, where, getDocs, orderBy, updateDoc, doc } from "firebase/firestore";
import { db } from "../../firebase";
import { Helmet } from "react-helmet";
import Cookies from 'js-cookie';
import { useToast } from '../../components/ToastContext';
import Loading from '../../components/loading';
import { MdSearch, MdAdd, MdSettings, MdDisplaySettings, MdMoreHoriz, MdStar, MdOutlineAddTask, MdAddToQueue, MdClose, MdArrowBackIos } from 'react-icons/md';

import Addtask from './add-task';
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import SortableItem from './task-ws-sortable';

import './task-list-ws.css';
import { FaRegPaste } from 'react-icons/fa6';
export default function Projectstasklistws({ data = {} }) {
  const [searchParams] = useSearchParams();
  const puid = searchParams.get('puid');
  const taskuid = searchParams.get('taskuid');
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const adminguid = Cookies.get("adminguid");
  const [taskselectdata, settaskselectdata] = useState();
  const [projectdata, setProjectdata] = useState([]);
  const [showCreateTask, setShowCreateTask] = useState(false);
  useEffect(() => {

    fetchProjectsData(adminguid);
  }, [adminguid]);
  //
  useEffect(() => {
    if (taskuid) {
      settaskselectdata(taskuid);
    }
  }, [taskuid]);
  const fetchProjectsData = async () => {
    setIsLoading(true);
    try {
      const smsQuery = query(
        collection(db, "projectstask"),
        where("adminguid", "==", adminguid),
        where("puid", "==", data.puid),
        where("status", "==", true),
        orderBy("indexstage", "asc")
      );
      const smsSnapshot = await getDocs(smsQuery);
      const dataList = smsSnapshot.docs.map((docItem) => ({
        id: docItem.id,
        ...docItem.data()
      }));
      setProjectdata(dataList);
    } catch (error) {
      console.error("Error fetching projects:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDragEnd = async (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      const oldIndex = projectdata.findIndex((item) => item.id === active.id);
      const newIndex = projectdata.findIndex((item) => item.id === over.id);
      const newOrder = arrayMove(projectdata, oldIndex, newIndex);
      setProjectdata(newOrder);

      for (let i = 0; i < newOrder.length; i++) {
        const item = newOrder[i];
        const newIndexStage = newOrder.length - i; // descending
        if (item.indexstage !== newIndexStage) {
          await updateDoc(doc(db, "projectstask", item.id), { indexstage: newIndexStage });
        }
      }
    }
  };

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );
  const task_close = () => {

    navigate('/dashboard');
  };
  return (

    <>
      <div className='Workstation-header'>
        <table className='table-style' >
          <tbody>
            <tr>
              <td width='30px'><MdArrowBackIos onClick={task_close} className='icon' /></td>

              <td width='20px'>
                <MdAddToQueue
                  onClick={() => setShowCreateTask(data)}
                  title='Add new task'
                  className='taskicon'
                />

                {showCreateTask?.puid === data.puid && (
                  <Addtask
                    data={showCreateTask}
                    onClose={() => setShowCreateTask(false)}
                  />
                )}
              </td>
              <td> <div className='projectname-text' >
                {data?.projectname ? data.projectname : "Loading..."}
              </div></td>
              <td width='30px'><MdStar className='icon' /></td>

              <td width='25px'>
                <FaRegPaste
                  title='Paste Add new item'
                  className='taskicon'
                />
              </td>



              <td width='30px'><MdDisplaySettings className='icon'
                title='Manage Task'
              /></td>
            </tr>
          </tbody>
        </table>
      </div>

      {isLoading ? (
        <Loading />
      ) : projectdata.length === 0 ? (
        <p>No Project available.</p>
      ) : (
        <div className='tasklist-grid'>
          <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
            <SortableContext
              items={projectdata.map((item) => item.id)}
              strategy={verticalListSortingStrategy}
            >
              {projectdata.map((datarow) => (
                <SortableItem key={datarow.id} datarow={datarow} navigate={navigate} />
              ))}

            </SortableContext>
          </DndContext>
        </div>
      )}

    </>

  );
}
